export const OrderEntityType = {
  CONDITION: 'Condition',
  CONDITION_PRIOR_TO_TYPE: 'ConditionPriorToType',
};
